import { create } from 'zustand'
import type { MessageContext } from '../api/types'

interface PrivateRepliesState {
  /** Bot conversation id → the channel message the next message sent there answers. */
  pending: Record<string, MessageContext>
  start: (conversationId: string, context: MessageContext) => void
  clear: (conversationId: string) => void
}

/** Private replies being written (contract: "Restricted channels"). Kept for this session only. */
export const usePrivateReplies = create<PrivateRepliesState>((set) => ({
  pending: {},
  start: (conversationId, context) => set((s) => ({ pending: { ...s.pending, [conversationId]: context } })),
  clear: (conversationId) =>
    set((s) => {
      if (!(conversationId in s.pending)) return s
      const pending = { ...s.pending }
      delete pending[conversationId]
      return { pending }
    }),
}))
